import { ParameterType, Status } from 'Common/parameterEnums';
import { t } from 'i18next';
import { USER_CREATED_PARAMETER_SYSTEM_NAME_SUFFIX } from './constants';

/**
 * Generates a parameter system name from a string using the following criteria:
 * - replaces a single white space with a single underscore, then
 * - lowercases the string
 *
 * E.g: "a b   c  d" --> "a_b___c__d"
 *
 * @param str
 * @returns parameter system name
 */
export const generateParameterSystemName = (str: string) => {
    if (str?.trim().length === 0) {
        return '';
    }

    return str?.replace(/ /g, '_').toLowerCase() + USER_CREATED_PARAMETER_SYSTEM_NAME_SUFFIX;
};

export const getFormattedParameterStatus = (status: string) => {
    let formattedStatus = status;

    switch (status) {
        case Status.DRAFT:
            formattedStatus = 'Draft';
            break;
        case Status.READY_TO_DEPLOY:
            formattedStatus = 'Ready To Deploy';
            break;
        case Status.ACTIVE:
            formattedStatus = 'Active';
            break;
        case Status.PRIMING:
            formattedStatus = 'Priming';
            break;
        case Status.READY_TO_DELETE:
            formattedStatus = 'Ready To Delete';
            break;
        default:
            break;
    }
    return formattedStatus;
};

export const getFormattedParameterTypeDisplayName = (parameterType: string, count: 'singular' | 'plural') => {
    let result;

    switch (count) {
        case 'singular':
            result = t(`ParameterTypeDisplayName.singular.${parameterType}`);
            break;
        case 'plural':
            result = t(`ParameterTypeDisplayName.plural.${parameterType}`);
            break;
        default:
            result = '';
            break;
    }

    return result;
};

export const dependencyExist = (linkedRules: number[], childParamIds: number[]) => {
    return linkedRules.length + childParamIds.length > 0;
};

export const deletableParameterType = (parameterType: string) => {
    return parameterType === ParameterType.EXPRESSION || parameterType === ParameterType.VELOCITY;
};
